import { Button } from "@mantine/core";
import React from "react";

const Head = ({ title, button, onClick, customButton }) => {
  return (
    <div className="table-page-header">
      <h1 className="table-page-title">{title}</h1>
      <div className="table-page-actions">
        {customButton}
        {button && (
          <Button onClick={onClick} size="sm">
            {button}
          </Button>
        )}
      </div>
    </div>
  );
};

export default Head;
